/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {ReelConstants} from '@gongxigames/framework/slot/utils';
import {Container} from 'pixi.js';
import {ANTICIPATION_CONFIG, anticipatorStore} from '@gongxigames/framework/slotV2/modules/anticipator/anticipatorStore';
import {$GameOrientationAlignContainer} from '@gongxigames/framework/slotV2/JSX/GameOrientationAlignContainer';
import {$Spine} from '@gongxigames/framework/core/fragments/BuilderY';
import {Spine} from '@gongxigames/framework/core';

type AnticipatorViewV2Options = {
    onStarted: () => void;
    onFinished: () => void;
};

export class AnticipatorViewV2 {
    public static readonly NAME: symbol = Symbol('AnticipatorViewV2');

    public container!: Container;

    constructor(protected options: AnticipatorViewV2Options) {
        this.init();
    }

    public _anticipator!: Spine;
    public init(): void {
        this.createMainScene();
    }

    protected createMainScene(): void {

        this.container = <$GameOrientationAlignContainer
            /* TODO ppositions calculated from game config curring via constructor from module,
               maybe need to put in act on inititialisation game for all components that use the same cuclulations for
               reels, respinreels, minispinreels */
            name='anticipator'
            portrait={{align: 0.5, offset: [-ANTICIPATION_CONFIG.width / 2, -ANTICIPATION_CONFIG.height / 2]}}
            landscape={{align: 0.5, offset: [-ANTICIPATION_CONFIG.width / 2, -ANTICIPATION_CONFIG.height / 2]}}
        >
            {this.createAnticipation()}
        </$GameOrientationAlignContainer> as Container;
    }

    public createAnticipation(): Container {

        this._anticipator = <$Spine
            spine={'ui_hyperspin'}
            visible={false}
        /> as Spine;
        const container = new Container();

        container.addChild(this._anticipator);

        return container;
    };

    public play(reelIndex: number): Promise<void> {

        this._anticipator.position.set(ReelConstants.SYMBOL_SLOT.width * reelIndex, 0);
        this._anticipator.visible = true;
        this._anticipator.start();

        return new Promise<void>(resolve => {
            this._anticipator?.state.clearListeners();
            (this._anticipator as Spine)?.setAnimation({

                animationName: 'idle',
                loop: false,
                listeners: {
                    start: () => {
                        this.options.onStarted();
                    },
                    complete: () => {
                        resolve();
                        this._anticipator.visible = false;
                        this._anticipator.stop();
                        this.options.onFinished();
                    }
                }
            });
        });

    }

    public stopAnticipationAnimation(): void {
        this._anticipator.stop();
        this.options.onFinished();
        this._anticipator.visible = false;
        anticipatorStore.anticipatedReels.value = [];
    }
}
